import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef  } from '@angular/core';
import * as _moment from 'moment';
import { Reg } from 'src/app/shared/reg.model';
import { RegService } from 'src/app/shared/Reg.Service';
import { Resp } from 'src/app/shared/resp.model';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { AppInsightsService } from 'src/app/shared/AppInsights.Service';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss'],
})
export class StepOneComponent implements OnInit {
  public type: string;
  public showPlaceholder: boolean;
  public show = false;
  @Input() userid: string;
  @Input() govid: string = '';
  @Input() email: string = '';
  @Input() pnumber: string = '';
  public pasteData = '';
  public radioSelected = 'life';
  public showNext = false;
  public isLoading = false;
  error: boolean;
  message: any;
  public dob: Date;
  public resp: Resp;
  public uuid: string;
  public validate = true;
  public formErrorFields: any = {
    emailReq: false,
    emailVal: false,
    pnumberReq: false,
    govidReq: false,
    govidVal: false,
    option: false
  };
  constructor(public regService: RegService, private appInsightsService: AppInsightsService) {}
  
  @ViewChild("em") em: ElementRef;
  @ViewChild("policy") policy: ElementRef;
  @ViewChild("ssn") ssn: ElementRef;
  
  ssnmask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // 000-00-0000
  maskedInputController;

  ngOnInit() {	
    window.scroll(0,0);
    this.type = 'password'; // display as '*'
    this.showPlaceholder = true;
    this.generateSession();
    this.appInsightsService.logEvent("Trust Registration UI Step One");
  }

  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }

  emailCheck() {
    const regex = /^(([^<>()\[\]\\.,;:\s@"*~]+(\.[^<>()\[\]\\.,;:\s@"*~]+)*)|(".+"))@((([a-zA-Z0-9\-]+\.)+[a-zA-Z0-9]{2,10}))$/;
    if (!regex.test(this.email)) {
      return true;
    } else {
      return false;
    }
  }

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }
  
  radioChanged(model) {
  	if (model === 'life') {
  		this.validate = false;
  		this.showNext = false;
  	} else if (model === 'corp') {
  		this.showNext = true;
  		setTimeout(() => {
	      this.maskedInputController = textMask.maskInput({
	        inputElement: this.ssn.nativeElement,
	        mask: this.ssnmask,
	        guide: false
	      });
	    });
  	}
  }
  
  focusOnInput() {
  		let setError = false; 
	  	if (!!this.formErrorFields.emailReq || !!this.formErrorFields.emailVal) {
	  		setError = true; 
	  		setTimeout(() => this.em.nativeElement.focus(), 0);
	  		setTimeout(() => this.em.nativeElement.select(), 0);
	  		window.scrollTo(0,this.em.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	  	} else if (!!this.formErrorFields.pnumberReq) {
	  		setError = true; 
	  		setTimeout(() => this.policy.nativeElement.focus(), 0);
	  		setTimeout(() => this.policy.nativeElement.select(), 0);
	  		window.scrollTo(0,this.policy.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	  	} else if (!!this.formErrorFields.govidReq || !!this.formErrorFields.govidVal) {
	  		setError = true; 
	  		setTimeout(() => this.ssn.nativeElement.focus(), 0);
	  		setTimeout(() => this.ssn.nativeElement.select(), 0);
	  		window.scrollTo(0,this.ssn.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	  	}
	  	
	  return setError;
  }
  
  isErrorPresent() {
  	if (!this.formErrorFields.emailReq && !this.formErrorFields.emailVal && !this.formErrorFields.pnumberReq 
  		&& !this.formErrorFields.govidReq && !this.formErrorFields.govidVal) {
        	return false;
        } else {
        	return true;
        }    
  }
  
  validateAllFields() {
  	const fields = ['email','pnumber','govid'];
  	let isErrPresent = false;
  	for (let j=0; j<fields.length; j++) {
  		isErrPresent = this.validateForm(fields[j]);
  		if (isErrPresent) {
  			break;
  		}
  	}
  	return isErrPresent;
  }
  
  ifAtleastOneFieldValidated(model) {
  	this.validate = !!this[model] ? false : true;
  	return this.validate;
  }

  validateForm(model) {
    let error = false;
    this.validate = true;
    
    if (model === 'email') {
      	if (!this.email) {
      		error = true;
      		this.formErrorFields.emailReq = true;
      		this.formErrorFields.emailVal = false;
    	} else if (this.emailCheck()) {
    		error = true;
      		this.formErrorFields.emailReq = false;
      		this.formErrorFields.emailVal = true;
    	} else {
      		this.formErrorFields.emailReq = false;
      		this.formErrorFields.emailVal = false;
      		this.ifAtleastOneFieldValidated(model);
    	}
    }
    
    if (model === 'pnumber') {
      	if (!this.pnumber) {
      		error = true;
      		this.formErrorFields.pnumberReq = true;
    	} else {
      		this.formErrorFields.pnumberReq = false;
      		this.ifAtleastOneFieldValidated(model);
    	}
    }
    
    if (model === 'govid') {
      if (!this.govid) {
        this.formErrorFields.govidReq = true;
        this.formErrorFields.govidVal = false;
        error = true;
      } else if (this.govid !== '' && this.govid.replace(/[- ()]/g, '').length !== 9) {
        this.formErrorFields.govidReq = false;
        this.formErrorFields.govidVal = true;
        error = true;
      } else {
        this.formErrorFields.govidReq = false;
        this.formErrorFields.govidVal = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
  
    console.log(this.formErrorFields, error);
    if (!!this.email && !!this.pnumber && !!this.govid && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }

  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }

  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }

  continue() {
    const reg = new Reg();
    reg.axassn = this.govid.replace(/[- ()]/g, '');
    reg.email = this.email;
    reg.policyNum = this.pnumber;
    reg.sessionId = this.uuid;

    if (this.pasteData.replace(/[- ()]/g, '') === this.govid.replace(/[- ()]/g, '')) {
      reg.ssnPasteEvent = 'Yes';
    } else {
      reg.ssnPasteEvent = 'No';
    }

    const bodyString = JSON.stringify(reg);
    if (this.radioSelected === 'life') {
    	setTimeout(() => {
	      	  window.scroll(0, 0);
	          this.error = false;
	          this.isLoading = true;
	          this.validate = true;
	      });
	      this.regService.regStepOne(bodyString).subscribe(res => {
	        this.resp = res;
	        if (this.resp && this.resp !== undefined && Object.keys(this.resp).length > 0) {
	            setTimeout(() => {
	                this.isLoading = false;
	            });
	          if (this.resp.status_code !== '200') {
	          	window.scroll(0, 0);
	            this.error = true;
	            this.validate = false;
	            this.message = this.resp.message;
	          } else {
	            console.log('url ' + this.resp.url);
	            window.location.href = window.location.origin + this.resp.url;
	          }
	        }
	      });
    } else {
    	if (!this.validateAllFields()) {
	      setTimeout(() => {
	      	  window.scroll(0, 0);
	          this.error = false;
	          this.isLoading = true;
	          this.validate = true;
	      });
	      this.regService.regStepOne(bodyString).subscribe(res => {
	        this.resp = res;
	        if (this.resp && this.resp !== undefined && Object.keys(this.resp).length > 0) {	            
	          if (this.resp.status_code !== '200') {
	            setTimeout(() => {
	                this.isLoading = false;
	            });
	          	window.scroll(0, 0);
	            this.error = true;
	            this.validate = false;
	            this.message = this.resp.message;
	            setTimeout(() => {
			      this.maskedInputController = textMask.maskInput({
			        inputElement: this.ssn.nativeElement,
			        mask: this.ssnmask,
			        guide: false
			      });
			    });
	          } else {
	            console.log('url ' + this.resp.url);
	            window.location.href = window.location.origin + this.resp.url;
	          }
	        }
	      });
	    } else {
	    	this.focusOnInput();
	    }
    }
    
  }

  generateSession() {
    let dt = new Date().getTime();
    this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
    function(c) {
      const r = (dt + Math.random() * 16) % 16 | 0; dt = Math.floor(dt / 16); return (c === 'x' ? r : (r & 0x3 | 0x8 )).toString(16);
    });
    console.log('session: ' + this.uuid);
  }
}
